<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('payList.uid')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>

						<el-form-item :label="$t('source.cname')" class="mb-0">
							<el-input size="small" v-model="from.cname" ></el-input>
						</el-form-item>

						<el-form-item :label="$t('source.dns_name')" class="mb-0">
							<el-input size="small" v-model="from.dns_name" ></el-input>
						</el-form-item>

						<el-form-item :label="$t('cdn.product')" class="mb-0">
							<el-select v-model="from.pid" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.product" :key="item.id" :label="item.name_uid" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('source.add')}}</el-button>
						<el-button size="small" v-if="layout.user.type==1" @click="getDnsName(false)" v-auth="'add'+auth_val" >{{$t('source.getDns')}}</el-button>
						<el-button size="small" v-if="layout.user.type==1" @click="alterDnsNameModel(false)" v-auth="'add'+auth_val" >{{$t('source.alterDns')}}</el-button>
						<el-button size="small" v-if="layout.user.type==1" @click="addSsl()" v-auth="'add'+auth_val" >{{$t('cdn.addSsl')}}</el-button>
						<!-- 切换渠道按钮 -->
						<el-button size="small" type="warning" @click="openChannelSwitchDialog">{{$t('cdn.switchChannel')}}</el-button>
						<!-- 导出按钮（参考 domain.vue） -->
						<el-button size="small" v-if="layout.user.type==1" @click="sendExcel()">{{$t('cdn.sendExcel')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
				<el-table-column
				      type="selection"
				      width="45">
				    </el-table-column>
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>

				<el-table-column align="center" width="140" prop="user_name" :label="$t('payList.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
			
				<el-table-column  align="center" prop="name" :label="$t('source.name')" >
				</el-table-column>
			
				<el-table-column  align="center" prop="cname" :label="$t('source.cname')" >
				</el-table-column>
			
				<el-table-column  align="center" prop="dns_name" :label="$t('source.dnsName')" >
				</el-table-column>
			
				<el-table-column  align="center" prop="domain_count" :label="$t('source.domain_count')" width="150">
					<template slot-scope="scope">
						<span style="color: #999;">{{ scope.row.domain_count }}</span>
						/
						<span style="color: #999;">{{ scope.row.domain_sync_count }}</span>
						<span @click="checkDomainDetail(scope.row)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="scope.row.domain_load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
					</template>
				</el-table-column>


				<el-table-column  align="center" prop="cert_count" :label="$t('source.cert_count')" width="150">
					<template slot-scope="scope">
						<span style="color: #999;">{{ scope.row.cert_count }}</span>
						/
						<span style="color: #999;">{{ scope.row.cert_sync_count }}</span>
						<span @click="checkCertDetail(scope.row,1)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="scope.row.cert_load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
					</template>
				</el-table-column>


				<el-table-column  align="center" prop="channel_num" :label="$t('source.channel_num')" width="150">
					<template slot-scope="scope">
						<span style="color: #999;">{{ scope.row.channel_num }}</span>
						<span @click="checkCertDetail(scope.row,2)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="scope.row.cert_load_channel==0?'el-icon-refresh':'el-icon-loading'"></i></span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="get_status" :label="$t('source.get_status')" width="100">
					<template slot-scope="scope">
						<span style="color: #999;" v-if="scope.row.get_status==3">{{$t('source.get_status3')}}</span>
						<span class="text-success" v-if="scope.row.get_status==1">{{$t('source.get_status1')}}</span>
						<span class="text-danger" v-if="scope.row.get_status==2">{{$t('source.get_status2')}}</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="c_name" :label="$t('source.cloud_name')">
					<template slot-scope="scope">
						<span class="text-success">{{scope.row.c_name}}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="sourceStr" :label="$t('source.sourceStr')" width="170">

				</el-table-column>
				
				<el-table-column prop="id" align="center" :label="$t('layout.operation')" >
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val"  @click="openModel(scope.row)">{{$t('layout.operation')}}</el-button>
							<el-button @click="syncCert(scope.row)" v-auth="'edit'+auth_val"  size="mini" plain type="success">{{$t('source.syncCert')}}</el-button>
							<el-button @click="syncDomain(scope.row)" v-auth="'edit'+auth_val"  size="mini" plain type="success">{{$t('source.syncDomain')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val"  size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
							<el-button @click="deleteDomain(scope.row)" v-auth="'del'+auth_val"  size="mini" plain type="danger">{{$t('source.deleteDomain')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('source.editSource') : $t('source.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('source.userName')" prop="user_id">
					<el-select v-model="form.user_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.allAccount" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item :label="$t('source.name')" prop="name">
					<el-input  v-model="form.name"  :placeholder="$t('source.name')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>

				<el-form-item :label="$t('source.sourceList')" prop="sourceList">
					<el-button @click="addSource(false)" style="margin-bottom: 10px;">{{ $t('source.addSource') }}</el-button>
								<el-table :data="form.sourceList" border style="width: 100%" @selection-change="handleSelectionChange">
									
									<el-table-column align="center" prop="type" :label="$t('source.type')">
										<template slot-scope="v">
											<el-tag v-if="v.row.type==1" >{{$t('source.type1')}}</el-tag>
											<el-tag v-if="v.row.type==2" >{{$t('source.type2')}}</el-tag>
										</template>
									</el-table-column>
									
									<el-table-column align="center" prop="source" :label="$t('source.source')"></el-table-column>
									<el-table-column align="center" prop="port" :label="$t('source.port')"></el-table-column>
									<el-table-column align="center" prop="weight" :label="$t('source.weight')"></el-table-column>
									<el-table-column align="center" prop="priority" :label="$t('source.priority')"></el-table-column>

									<el-table-column prop="id" align="center" width="140" :label="$t('layout.operation')">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" plain type="primary" @click="addSource(scope)">{{ $t('layout.operation') }}</el-button>
												<el-button @click="delSource(scope)" :disabled="scope.row.is_default ? true : false" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
				</el-form-item>
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('system.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>



		
		<el-dialog :close-on-click-modal="false"   :title="editSourceIndex > -1 ? $t('source.editSource') : $t('source.addSource')" :append-to-body="true" :visible.sync="createSourceModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rulesSource" ref="formSource" :model="formSource" :label-width="layout.is_phone?'80px':'100px'">
							
					<el-form-item :label="$t('source.type')">
						<el-radio-group  v-model="formSource.type" size="small">
							<el-radio :label="1" border>{{$t('source.type1')}}</el-radio>
							<el-radio :label="2" border>{{$t('source.type2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
				
					<el-form-item :label="$t('source.source')" prop="source">
						<el-input v-model="formSource.source" :placeholder="$t('source.source')" clearable size="small" style="width: 85%;" ></el-input>
					</el-form-item>

					<el-form-item :label="$t('source.port')" prop="port">
						<el-input v-model="formSource.port" type="number" :placeholder="$t('source.port')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>

					<el-form-item :label="$t('source.weight')" prop="weight">
						<el-input v-model="formSource.weight" type="number" :placeholder="$t('source.weight')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item :label="$t('source.priority')" prop="priority">
						<el-input v-model="formSource.priority" type="number" :placeholder="$t('source.priority')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
					</el-form-item>
					
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createSourceModel = false">{{$t('system.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitSource">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>


		
		<el-dialog :close-on-click-modal="false"   :title="editSourceDnsIndex > -1 ? $t('source.editSource') : $t('source.addSource')" :append-to-body="true" :visible.sync="createSourceDnsModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rulesDns" ref="formSourceDns" :model="formSourceDns" :label-width="layout.is_phone?'80px':'100px'">
							
					<el-form-item :label="$t('source.DnsType')">
						<el-radio-group  v-model="formSourceDns.type" size="small">
							<el-radio :label="1" border>{{$t('source.DnsType1')}}</el-radio>
							<el-radio :label="2" border>{{$t('source.DnsType2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
				
					<el-form-item :label="$t('source.DnsName')" prop="source">
						<el-input v-model="formSourceDns.source" :placeholder="$t('source.DnsName')" clearable size="small" style="width: 85%;" ></el-input>
					</el-form-item>

				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createSourceDnsModel = false">{{$t('system.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="alterDnsName">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

		<!-- 切换渠道弹窗 -->
		<el-dialog :close-on-click-modal="false" :title="$t('cdn.switchChannel')" :visible.sync="channelSwitchDialog" top="5vh" :width="layout.is_phone?'90%':'60%'" :append-to-body="true" custom-class="custom-dialog">
			<div style="max-height: 65vh; overflow: auto;">
				<el-form :model="channelForm" :label-width="layout.is_phone?'80px':'120px'">
					<el-form-item :label="$t('cdn.selectChannel')">
						<el-select v-model="channelForm.channel_id" size="small" filterable placeholder="请选择渠道" style="width: 100%;">
							<el-option v-for="item in channelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="操作类型">
						<el-radio-group v-model="channelForm.action_type" size="small">
							<el-radio :label="1" border>预加载</el-radio>
							<el-radio :label="2" border>切换CNAME</el-radio>
						</el-radio-group>
					</el-form-item>
					
					<el-form-item :label="$t('cdn.selectedDomains')">
						<div style="display: flex; align-items: center; gap: 20px;">
							<!-- 方式一：选中数据 -->
							<div style="flex: 1;">
								<el-tag type="primary" size="medium">
									{{ $t('cdn.selectedData') }}：{{ selectedDomainCountComputed }} {{ $t('cdn.unitCount') }}
								</el-tag>
								<div style="font-size: 12px; color: #909399; margin-top: 5px;">
									{{ $t('cdn.selectedHint') }}
								</div>
							</div>
							
							<!-- 方式二：上传Excel -->
							<div style="flex: 1;">
								<el-upload
									ref="excelUpload"
									:disabled="!canUploadExcel"
									:show-file-list="false"
									:auto-upload="false"
									accept=".xlsx,.xls"
									:before-upload="beforeExcelUpload"
									:on-change="handleExcelLocalChange"
									:http-request="() => {}"
									style="display: inline-block;">
									<el-button 
										:disabled="!canUploadExcel" 
										size="small" 
										type="success">
										{{ $t('cdn.uploadExcel') }}
									</el-button>
								</el-upload>
								<div v-if="excelDomainCount > 0" style="margin-top: 5px;">
									<el-tag type="success" size="medium">
										{{ $t('cdn.excelData') }}：{{ excelDomainCount }} {{ $t('cdn.unitCount') }}
									</el-tag>
								</div>
								<div style="font-size: 12px; color: #909399; margin-top: 5px;">
									{{ hasSelected ? $t('cdn.hasSelectionNoUpload') : $t('cdn.uploadExcelHint') }}
								</div>
							</div>
						</div>
					</el-form-item>
					
					<el-form-item :label="$t('cdn.totalDomains')">
						<el-tag type="warning" size="large">
							{{ listTotalCount }} {{ $t('cdn.unitCount') }}
						</el-tag>
						<div style="font-size: 12px; color: #909399; margin-top: 5px;">
							{{ $t('cdn.totalDomainsHint') }}
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button :disabled="layout.loading" @click="channelSwitchDialog = false">{{$t('system.cancel')}}</el-button>
				<el-button 
					type="primary" 
					:disabled="!canSwitchChannel || layout.loading"
					:loading="layout.loading"
					@click="confirmSwitchChannel">
					{{$t('system.confirm')}}
				</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	import XLSX from 'xlsx';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createSourceDnsModel: false,
				editSourceDnsIndex: -1,
				formSourceDns:{
					type: 1,
					source: '',
				},

				createSourceModel: false,
				editSourceIndex: -1,

				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					name: '',
					dns_name: '',
					cname: '',
					pid:-1,
					user_id:-1,
					sourceList:[],
					time:[],
				},
				auth_val: 'Source',
				odds:0,
				preUrl: "data/sourceList", //列表地址
				delAllUrl: "data/delSourceAll", //批量删除地址
				delUrl: "data/delSource", //删除單条地址
				addUrl: "data/addCdnSource", //添加/修改地址
				editStatusUrl:"data/editStatusSource",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {
					name: '',
					user_id:'',
					sourceList:[]
				},
				

				rulesDns: {
					source: [{
						required: true,
						message: this.$t('source.sourceDnsRequired'),
						trigger: 'blur',
					}]
				},

				rules: {
					name: [{
						required: true,
						message: this.$t('userList.nameRequired'),
						trigger: 'blur',
					}],
					sourceList: [{
						required: true,
						message: this.$t('source.sourceListRequired'),
						trigger: 'blur',
					}],
					user_id: [{
						required: true,
						message: this.$t('source.selUser'),
						trigger: 'blur',
					}],
				},
				
				formSource:{
					source:'',
					id:0,
					type:1,
					port:80,
					weight:1,
					priority:1,
				},
				rulesSource: {
					source: [
						{
							required: true,
							message: this.$t('userList.sourceRequired'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (!value) {
									return callback();
								}

								const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
								const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

								if (domainRegex.test(value) || ipRegex.test(value)) {
									callback();
								} else {
									callback(new Error('请输入有效的域名或IP地址'));
								}
							},
							trigger: 'blur'
						}
					],
					port: [{
						required: true,
						message: this.$t('userList.portRequired'),
						trigger: 'blur',
					}],
					weight: [{
						required: true,
						message: this.$t('userList.weightRequired'),
						trigger: 'blur',
					}],
					priority: [{
						required: true,
						message: this.$t('userList.priorityRequired'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[],
				// 渠道切换弹窗相关
				channelSwitchDialog: false,
				channelForm: {
					channel_id: '',
					action_type: 1,
				},
				channelList: [],
				selectedDomainCount: 0,
				excelDomainCount: 0,
				totalDomainCount: 0,
				excelIds: [],
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
			hasSelected() {
				return (this.multipleSelection && this.multipleSelection.length > 0);
			},
			selectedDomainCountComputed() {
				return this.hasSelected ? this.multipleSelection.length : 0;
			},
			canUploadExcel() {
				// 当有选中数据时禁止上传
				return !this.hasSelected;
			},
			listTotalCount() {
				// 使用公共分页的总数
				return this.page.total || 0;
			},
			canSwitchChannel() {
				// 渠道ID为0时也应视为有效，故不使用!!强转，直接判定非空和非undefined
				const channelSelected = this.channelForm.channel_id !== '' && this.channelForm.channel_id !== null && this.channelForm.channel_id !== undefined;
				const hasExcelIds = Array.isArray(this.excelIds) && this.excelIds.length > 0;
				return channelSelected && (this.hasSelected || hasExcelIds);
			}
		},
		created() {
			this.commonList(['user','cdn_cloud','domain']);
		},
		methods: {
			sendExcel(){
				// 参考 domain.vue：未勾选则按筛选条件导出并二次确认
				if (this.ids.length === 0) {
					const hasFilters = !!(this.from && (
						(this.from.name && this.from.name.trim() !== '') ||
						(this.from.cname && this.from.cname.trim() !== '') ||
						(this.from.dns_name && this.from.dns_name.trim() !== '') ||
						(Array.isArray(this.from.time) && this.from.time.length === 2)
					));
					const msg = hasFilters ? this.$t('cdn.exportConfirmWithFilters') : this.$t('cdn.exportConfirmAll');
					this.$confirm(msg, this.$t('system.prompt'), {
						confirmButtonText: this.$t('system.confirm'),
						cancelButtonText: this.$t('system.cancel'),
						type: 'warning'
					}).then(() => {
						this.layout.loading = true;
						this.axios.post('/admin/data/sendSourceExcel', {
							ids: this.ids,
							type: 1,
							search: this.from
						}, {
							token: true,
						}).then(res => {
							this.layout.loading = false;
							if (res.data && res.data.code === 1 && res.data.data && res.data.data.list) {
								const downloadUrl = res.data.data.list;
								const link = document.createElement('a');
								link.href = downloadUrl;
								link.download = 'source_list.xlsx';
								document.body.appendChild(link);
								link.click();
								document.body.removeChild(link);
								this.$message.success(this.$t('cdn.sendExcelSuccess'));
							} else {
								this.$message.success(this.$t('cdn.sendExcelSuccess'));
							}
						}).catch(() => {
							this.layout.loading = false;
							this.$message.error(this.$t('cdn.sendExcelFailed'));
						})
					}).catch(() => {
						this.$message.info(this.$t('message.cancelOperate'));
					});
					return;
				}

				// 已勾选时直接导出
				this.layout.loading = true;
				this.axios.post('/admin/data/sendExcel', {
					ids:this.ids,
					type:1
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					if (res.data && res.data.code === 1 && res.data.data && res.data.data.list) {
						const downloadUrl = res.data.data.list;
						const link = document.createElement('a');
						link.href = downloadUrl;
						link.download = 'source_list.xlsx';
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.$message.success(this.$t('cdn.sendExcelSuccess'));
					} else {
						this.$message.success(this.$t('cdn.sendExcelSuccess'));
					}
				}).catch(() => {
					this.layout.loading = false;
					this.$message.error(this.$t('cdn.sendExcelFailed'));
				})
			},
			// 打开渠道切换弹窗
			openChannelSwitchDialog() {
				this.channelSwitchDialog = true;
				this.channelForm.channel_id = null; // 清空默认值，避免0被误判
				this.channelForm.action_type = 1; // 默认预加载
				this.selectedDomainCount = 0;
				this.excelDomainCount = 0;
				this.totalDomainCount = 0;
				this.excelIds = [];
			},
			handleExcelLocalChange(file, fileList) {
				// 前端解析 Excel，取第一列作为 ID，跳过第一行
				this.parseExcelFile(file && file.raw);
			},
			parseExcelFile(rawFile) {
				try {
					const raw = rawFile;
					if (!raw) return false;
					const reader = new FileReader();
					reader.onload = (e) => {
						try {
							const data = new Uint8Array(e.target.result);
							const wb = XLSX.read(data, { type: 'array' });
							const wsName = wb.SheetNames[0];
							if (!wsName) {
								this.$message.error(this.$t('cdn.uploadExcelFailed'));
								return;
							}
							const ws = wb.Sheets[wsName];
							const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });
							const ids = [];
							for (let i = 1; i < rows.length; i++) { // 跳过第一行
								const row = rows[i];
								if (!row || row.length === 0) continue;
								let id = row[0];
								if (id === undefined || id === null || id === '') continue;
								if (typeof id === 'string') id = id.trim();
								// 仅接受数字或数字字符串
								if ((typeof id === 'number' && !isNaN(id)) || (/^\d+$/.test(String(id)))) {
									ids.push(String(id));
								}
							}
							this.excelIds = ids;
							this.excelDomainCount = ids.length;
							this.totalDomainCount = ids.length;
							if (ids.length > 0) {
								this.$message.success(this.$t('cdn.uploadExcelSuccess'));
							} else {
								this.$message.warning(this.$t('cdn.uploadExcelFailed'));
							}
						} catch (err) {
							this.$message.error(this.$t('cdn.uploadExcelFailed'));
						}
					};
					reader.readAsArrayBuffer(raw);
					return false;
				} catch (err) {
					this.$message.error(this.$t('cdn.uploadExcelFailed'));
					return false;
				}
			},
			beforeExcelUpload(file) {
				if (this.hasSelected) {
					this.$message.warning(this.$t('cdn.hasSelectionNoUpload'));
					return false; // 阻止
				}
				const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel';
				if (!isExcel) {
					this.$message.error(this.$t('cdn.onlyExcel'));
					return false; // 阻止
				}
				const isLt1M = file.size / 1024 / 1024 < 1; // 限制1MB
				if (!isLt1M) {
					this.$message.error(this.$t('cdn.excelTooLarge'));
					return false; // 阻止
				}
				// 解析并阻止默认上传
				this.parseExcelFile(file && file.raw);
				return false;
			},
			handleExcelSuccess(response, file, fileList) {
				if (response.code === 1) {
					const data = response.data;
					this.excelDomainCount = data.count || 0;
					this.totalDomainCount = data.total_count || 0;
					this.$message.success(this.$t('cdn.uploadExcelSuccess'));
				} else {
					this.$message.error(response.msg || this.$t('cdn.uploadExcelFailed'));
				}
			},
			handleExcelError(err, file, fileList) {
				this.$message.error(this.$t('cdn.uploadExcelFailed'));
			},
			confirmSwitchChannel() {
				
				// 注意：channel_id 可能为 0，也应视为有效
				if (this.channelForm.channel_id === '' || this.channelForm.channel_id === null || this.channelForm.channel_id === undefined) {
					this.$message.warning(this.$t('cdn.selectChannel'));
					return;
				}
				// 校验数据来源：优先选中行，其次 Excel 解析的 ids
				const useSelected = this.hasSelected && Array.isArray(this.ids) && this.ids.length > 0;
				const useExcel = !useSelected && Array.isArray(this.excelIds) && this.excelIds.length > 0;
				if (!useSelected && !useExcel) {
					this.$message.warning(this.$t('cdn.hasSelectionNoUpload'));
					return;
				}
				const destItem = (this.channelList || []).find(item => String(item.id) === String(this.channelForm.channel_id));
				const destName = destItem ? destItem.name : this.channelForm.channel_id;
				const switchCount = useSelected ? this.selectedDomainCountComputed : (this.excelIds ? this.excelIds.length : 0);
				this.$confirm(`${this.$t('cdn.selectedDomains')}: ${switchCount} ${this.$t('cdn.unitCount')}，${this.$t('cdn.switchChannel')} -> ${destName} ?`, this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.layout.loading = true;
					const idsToSend = useSelected ? this.ids : this.excelIds;

					this.axios.post('/admin/data/switchChannel', {
						ids: idsToSend,
						type: 2,
						action_type: this.channelForm.action_type,
						channel_id: this.channelForm.channel_id
					}, {
						token: true,
					}).then(res => {
						const data = res && res.data ? res.data : {};
						if (data.code === 1) {
							this.$message.success(this.$t('cdn.switchChannelSuccess'));
							this.getList();
							this.channelSwitchDialog = false;
						} else {
							this.$message.error(data.msg || this.$t('cdn.switchChannelFailed'));
						}
					}).catch(err => {
						this.$message.error(this.$t('cdn.switchChannelFailed'));
					}).finally(() => {
						this.layout.loading = false;
					});
				}).catch(() => {
					this.$message.info(this.$t('message.cancelOperate'));
				});
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('source.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('source.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			alterDnsNameModel(){
				if(this.ids.length==0){
					this.$message.error(this.$t('source.selSource'));
					return false
				}
				this.formSourceDns = {
					type: 1,
					source: '',
				},
				this.createSourceDnsModel = true;
			},
			alterDnsName(){
				this.$refs.formSourceDns.validate(res => {
					if (res) {
						this.layout.loading = true;
						this.formSourceDns.ids = this.ids
						this.axios.post('/admin/data/alterDnsName', this.formSourceDns, {
							token: true,
						}).then(res => {
							this.getList()
							this.createSourceDnsModel = false;
						}).catch(err => {
							// 失敗
							this.layout.loading = false;
						})
					}
				})
				
			},
			checkDomainDetail(item) {
				if(item.domain_load==1){
					return false;
				}
				item.domain_load = 1;
				this.axios.post('/admin/data/checkDomainDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					item.domain_sync_count = list.domain_sync_count
					item.domain_count = list.domain_count
					
					item.domain_load = 0;
				}).catch(err => {
					// 失敗
					item.domain_load = 0;
				})
			},

			deleteDomain(item) {
				this.layout.loading = true;
				this.axios.post('/admin/data/delSourceDomainAll', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},

			getDnsName() {
				if(this.ids.length==0){
					this.$message.error(this.$t('source.selSource'));
					return false
				}
				this.layout.loading = true;
				this.axios.post('/admin/data/getDnsName', {
					ids:this.ids
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					this.getList()
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			openChannelSwitchDialog() {
				this.channelSwitchDialog = true;
				this.channelForm.channel_id = null; // 清空默认值，避免0被误判
				this.selectedDomainCount = 0;
				this.excelDomainCount = 0;
				this.totalDomainCount = 0;
			},
			
			addSsl() {
				if(this.ids.length==0){
					this.$message.error(this.$t('source.selSource'));
					return false
				}

				this.layout.loading = true;
				this.axios.post('/admin/data/addSsl', {
					source_id:this.ids
				}, {
					token: true,
				}).then(res => {
					// let all = res.data
					// let list = all.data
					this.getList(); 
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},

			checkCertDetail(item,type) {
				if(type == 1){
					if(item.cert_load==1){
						return false;
					}
					item.cert_load = 1;
				}
				if(type == 2){
					if(item.cert_load_channel==1){
						return false;
					}
					item.cert_load_channel = 1;
				}
				
				this.axios.post('/admin/data/checkCertDetail', {
					id:item.id,
					type:type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					if(type == 1){
						item.cert_sync_count = list.cert_sync_count
						item.cert_count = list.cert_count
						item.cert_load = 0;
					}
					if(type == 2){
						item.channel_num = list.channel_num
						item.cert_load_channel = 0;
					}
					
					
				}).catch(err => {
					// 失敗
					item.cert_load = 0;
					item.cert_load_channel = 0;
				})
			},
			syncCert(e){
				this.layout.loading = true;
				this.axios.post('/admin/data/syncCert', {
					id:e.id
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			syncDomain(e){
				this.layout.loading = true;
				this.axios.post('/admin/data/syncDomain', {
					id:e.id
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						name: '',
						user_id:'',
						sourceList:[]
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						name: e.name,
						user_id: e.uid,
						sourceList:e.sourceList,
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			delSource(scope){
				// 獲取要刪除的名次 ID 或索引
				const index = scope.$index; // 行的索引
				this.form.sourceList.splice(index, 1); // 刪除對應行
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
					this.channelList = list.cdn_cloud
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},

			//添加修改源站列表
			addSource(e = false){
				if (!e) {
					// 初始化表單
					this.editSourceIndex = -1
				} else {
					// 修改
					this.formSource = {
						source: e.row.source,
						id: e.row.id,
						type: e.row.type,
						port: e.row.port,
						weight:e.row.weight,
						priority:e.row.priority,
					}
					this.editSourceIndex = e.$index
				}
			
				// 打开dialog
				this.createSourceModel = true
			},
			submitSource(){
				
				this.$refs.formSource.validate(valid => {
					if (valid) {
						if (this.editSourceIndex === -1) {
							// 添加新題目
							this.form.sourceList.push(this.formSource);
						} else {
							// 修改现有題目
							this.$set(this.form.sourceList, this.editSourceIndex, {...this.formSource});
						}
						
						// 重置表單和關閉模态框
						this.resetSourceForm();
					}
				});
			},
			resetSourceForm(){
				this.formSource = {
					source:'',
					id:0,
					type:1,
					port:80,
					weight:1,
					priority:1,
				}
				this.editSourceIndex = -1;
				this.createSourceModel = false;
			},
			// deleteItemSource(item) {
			// 	//询问层
			// 	this.$confirm(this.$t('source.confirmDelete'), this.$t('system.delete'), {
			// 		confirmButtonText: this.$t('system.confirm'),
			// 		cancelButtonText: this.$t('system.cancel'),
			// 		type: 'warning'
			// 	})
			// 	.then(() => {
			// 		this.deleteItem(item);
			// 	})
			// 	.catch(() => {
			// 		this.$message({
			// 			type: 'info',
			// 			message: this.$t('system.cancel')
			// 		});
			// 	});
			// },
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					pid:-1,
					dns_name: '',
					cname: '',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
